// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__vlgke","list":"list__mt2ws"};